module.exports = __webpack_public_path__ + "media/images/brand/logo-circular-e1e3e73896d40a1fd996001a4aa5acc4.svg";